var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 5.5C1.77614 5.5 2 5.72386 2 6C2 8.20913 3.79087 10 6 10C7.07919 10 8.05735 9.57292 8.77734 8.87793C8.97595 8.68622 9.29257 8.69217 9.48438 8.89062C9.67609 9.08922 9.6711 9.40585 9.47266 9.59766C8.57375 10.4654 7.34858 11 6 11C4.36398 11 2.91219 10.2137 2 8.99902V10C2 10.2761 1.77614 10.5 1.5 10.5C1.22386 10.5 1 10.2761 1 10V6C1 5.72386 1.22386 5.5 1.5 5.5ZM6 1C7.63573 1 9.08778 1.78565 10 3V2C10 1.72386 10.2239 1.5 10.5 1.5C10.7761 1.5 11 1.72386 11 2V6C11 6.27614 10.7761 6.5 10.5 6.5C10.2239 6.5 10 6.27614 10 6C10 3.79087 8.20913 2 6 2C4.86981 2 3.85012 2.46846 3.12207 3.22266C2.93028 3.42129 2.6137 3.42615 2.41504 3.23438C2.2164 3.04258 2.21057 2.72601 2.40234 2.52734C3.31103 1.58615 4.58755 1 6 1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.c8fd927c91319b30ae5dad5847e4b7ab.svg";
export { ForwardRef as ReactComponent };